import {useContext} from 'react';
import {Context} from '../context';

export function useCartItems() {
  const {cart} = useContext(Context);
  if (cart == null || cart.lines == null) {
    return [];
  }

  return cart.lines;
}